// extracted by mini-css-extract-plugin
module.exports = {"title":"AccommodationAvailableAddons_title__SQX9t"};